import { useState } from "react";

const faqs = [
  {
    question: "Une fenêtre aluminium se répare-t-elle facilement ?",
    answer:
      "Dans la grande majorité des cas, oui. Le cadre aluminium est extrêmement solide et ne bouge pas. C'est le mécanisme interne (crémone, poignée, gond) qui s'use ou se dérègle. Notre technicien ouvre le profilé, accède au mécanisme et remplace la pièce défectueuse. L'intervention dure en moyenne 45 minutes. Vous ne changez pas la fenêtre, seulement la pièce usée. Nous réparons plus de 90% des fenêtres aluminium rencontrées à Strasbourg et dans le Bas-Rhin.",
  },
  {
    question: "Les pièces de ferrure sont-elles spécifiques aux fenêtres aluminium ?",
    answer:
      "Oui, les ferrures aluminium sont dimensionnées pour des profilés fins et des vantaux souvent plus larges que ceux en PVC. Chaque fabricant de quincaillerie utilise des dimensions, des fixations et des couples de serrage propres. C'est pourquoi nous identifions la marque exacte sur place (GU, Roto, Siegenia, Winkhaus, Ferco, etc.) et utilisons la pièce de remplacement correspondante. Nos techniciens connaissent les références des principaux fournisseurs et arrivent avec un stock de pièces courantes. Si la pièce est rare, nous la commandons et revenons en 48h.",
  },
  {
    question: "Quel délai pour une réparation de fenêtre aluminium à Strasbourg ?",
    answer:
      "Les fenêtres aluminium nécessitent parfois des ferrures spécifiques aux profilés fins. Nous avons un stock de pièces courantes pour les marques les plus répandues (GU, Roto, Siegenia, Winkhaus). Dans la métropole de Strasbourg, nous intervenons le jour même ou le lendemain. Pour les communes plus éloignées du Bas-Rhin, le délai est de 24 à 48h. Le déplacement est gratuit.",
  },
  {
    question: "Le prix de la réparation est-il dans le devis ?",
    answer:
      "Oui, le devis détaillé inclut le déplacement, le diagnostic, la pièce neuve aluminium et la main d'œuvre. Les ferrures aluminium sont dimensionnées pour des vantaux plus larges et des profilés fins, ce qui peut légèrement influencer le prix par rapport au PVC. Le devis est transparent et sans frais cachés. Vous savez exactement ce que vous payez avant l'intervention. Garantie 10 ans.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="bg-rose-50 py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-plum-dark mb-8 md:mb-10">
            Questions fréquentes — réparation fenêtre Aluminium
          </h2>
          <div className="space-y-3 md:space-y-4">
            {faqs.map((faq, i) => {
              const isOpen = openIndex === i;
              return (
                <div
                  key={i}
                  className="bg-white rounded-2xl border border-rose-100 overflow-hidden"
                >
                  <button
                    onClick={() => setOpenIndex(isOpen ? null : i)}
                    className="w-full flex items-center justify-between gap-4 px-5 py-4 md:px-6 md:py-5 text-left"
                  >
                    <span className="font-semibold text-base md:text-lg text-plum-dark">
                      {faq.question}
                    </span>
                    <div className="w-8 h-8 rounded-full bg-rose-50 flex items-center justify-center shrink-0">
                      <i className={`ri-${isOpen ? "subtract" : "add"}-line text-plum`} />
                    </div>
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5 md:px-6 md:pb-6">
                      <p className="text-sm md:text-base text-plum-dark/80 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}